import styled from '@emotion/styled';

export const SFooter = styled.div`
  display: flex;
  justify-content: flex-end;
`;
